import { render, staticRenderFns } from "./board-revenue-report.vue?vue&type=template&id=4f97834e&scoped=true"
import script from "./board-revenue-report.vue?vue&type=script&lang=js"
export * from "./board-revenue-report.vue?vue&type=script&lang=js"
import style0 from "./board-revenue-report.vue?vue&type=style&index=0&id=4f97834e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f97834e",
  null
  
)

export default component.exports